<template>
  <div class="dashboard wrap">
    <div class="back-link">
      <router-link :to="{name: 'Dashboard'}" class="d-flex align-center">
        <rir-icon icon="arrow-left" size="12" class="mr-2"/>
        Назад к сводке
      </router-link>
    </div>
    <h1>
      Оперативная сводка по обстановке <br>
      на территории МО г. Южно-Сахалинск
    </h1>
    <CurrentDate />
    <component
      v-if="!isLoadData"
      :is="isComponentForm"
      :kpi="kpi"
    />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import CurrentDate from "@/components/CurrentDate";
import ConstructorForm from "@/components/kpiForm/ConstructorForm";
import DefaultForm from "@/components/kpiForm/DefaultForm";

export default {
  name: 'DashboardCardEdit',
  components: {CurrentDate},
  data: () => ({
    isLoadData: true
  }),
  props: {
    uuid: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...mapState('kpi', ['kpi']),
    isComponentForm () {
      return this.kpi.maxChildrenCount > 0 ? ConstructorForm : DefaultForm
    }
  },
  mounted () {
    this.loadKpi();
  },
  methods: {
    ...mapActions('kpi', ['getKpiData']),
    loadKpi () {
      this.isLoadData = true
      if (this.kpi.id !== this.uuid) {
        this.getKpiData(this.uuid)
        .catch(() => {
          this.$router.push({ name: 'Dashboard'})
        })
        .finally(() => {
          this.isLoadData = false
        })
      } else {
        this.isLoadData = false
      }
    }
  }
}
</script>

<style scoped>

</style>
